import {Component, inject, signal} from '@angular/core';
import {NgClass} from '@angular/common';
import {RouterLink, RouterOutlet} from '@angular/router';
import {FormsModule} from '@angular/forms';
import {LiquidContainer} from './components/liquid-container/liquid-container';
import {NgbTooltip} from '@ng-bootstrap/ng-bootstrap';
import {ThemeService} from './services/theme.service';

interface BeforeInstallPromptEvent extends Event {
  prompt(): Promise<void>;
  userChoice: Promise<{outcome: 'accepted' | 'dismissed'}>;
}

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    FormsModule,
    RouterLink,
    NgClass,
    LiquidContainer,
    NgbTooltip,
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class App {
  protected theme = inject(ThemeService);

  online = signal(navigator.onLine);
  installAvailable = signal(false);
  private installPrompt?: BeforeInstallPromptEvent;

  constructor() {
    window.addEventListener('online', () => this.online.set(true));
    window.addEventListener('offline', () => this.online.set(false));

    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.installPrompt = event as BeforeInstallPromptEvent;
      this.installAvailable.set(true);
    });

    window.addEventListener('appinstalled', () => {
      this.installPrompt = undefined;
      this.installAvailable.set(false);
    });
  }

  async installApp() {
    const prompt = this.installPrompt;
    if (!prompt) return;
    await prompt.prompt();
    const choice = await prompt.userChoice;
    this.installPrompt = undefined;
    this.installAvailable.set(false);
    window.umami?.track('installPwa', { outcome: choice.outcome });
  }
}
